module.exports = __webpack_public_path__ + "img/jbq.c790795f.gif";